import type { ReactNode } from 'react'

import { BuildingSearchIcon, CalculatorIcon, ContractIcon, DollarShinyIcon } from 'components/new-icons'

export type HomeRenovationSimulationStep = {
  id: string
  order: number
  icon: ReactNode
  title: string
  description: ReactNode
}

export const homeRenovationSimulationSteps: HomeRenovationSimulationStep[] = [
  {
    id: 'simulation',
    order: 0,
    icon: <CalculatorIcon color="var(--colors-blue-icon-default)" />,
    title: 'Simulação',
    description: (
      <>
        Escolha o <strong>valor do empréstimo</strong> que deseja e <strong>faça uma simulação rápida</strong>. Em
        apenas 3 minutos, você já tem uma prévia do seu crédito!
      </>
    )
  },
  {
    id: 'evaluation',
    order: 1,
    icon: <BuildingSearchIcon color="var(--colors-blue-icon-default)" />,
    title: 'Avaliação',
    description: (
      <>
        <strong>Analisamos seu perfil e imóvel de forma rápida e segura</strong>, oferecendo uma solução de crédito sob
        medida para você.
      </>
    )
  },
  {
    id: 'signature',
    order: 2,
    icon: <ContractIcon color="var(--colors-blue-icon-default)" />,
    title: 'Assinatura',
    description: (
      <>
        Com o crédito aprovado, <strong>organizamos toda a documentação</strong> e preparamos para a{' '}
        <strong>assinatura digital</strong>.
      </>
    )
  },
  {
    id: 'money-released',
    order: 3,
    icon: <DollarShinyIcon color="var(--colors-blue-icon-default)" />,
    title: 'Dinheiro liberado',
    description: (
      <>
        Contrato assinado e registrado em cartório? <strong>Agora é só receber o dinheiro e usar como quiser!</strong>
      </>
    )
  }
]
